export const CreateTicketInitialValues = {
  ticket_title: '',
  ticket_description: '',
  assignee_uuid: '',
  ticket_end_job_type_uuid: '',
}
